/**
 * Replaces cart line item images with doormat configurator previews when available.
 */
function applyDoormatCartPreviews(root = document) {
  root.querySelectorAll('[data-doormat-configuration]').forEach((row) => {
    if (!(row instanceof HTMLElement)) return;

    const configurationId = row.dataset.doormatConfiguration;
    const previewUrl = row.dataset.doormatPreviewImage;
    const media = row.querySelector('.cart-items__media');
    const image = media?.querySelector('.cart-items__media-image');

    if (!media || !configurationId) return;

    let src = previewUrl || null;

    if (!src) {
      try {
        src = sessionStorage.getItem(`doormat-preview:${configurationId}`);
      } catch {
        src = null;
      }
    }

    if (!src) return;

    if (image instanceof HTMLImageElement) {
      image.src = src;
      image.alt = image.alt || 'Configured doormat preview';
      return;
    }

    const link = media.querySelector('.cart-items__media-container');
    if (!(link instanceof HTMLAnchorElement)) return;

    const img = document.createElement('img');
    img.className = 'cart-items__media-image border-style doormat-cart-preview-image';
    img.src = src;
    img.alt = 'Configured doormat preview';
    img.loading = 'lazy';
    link.appendChild(img);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  applyDoormatCartPreviews();
});

document.addEventListener('cart:update', () => {
  applyDoormatCartPreviews();
});

const observer = new MutationObserver(() => {
  applyDoormatCartPreviews();
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});
